import { isImpersonating, useImpersonationStore } from '../store/impersonation';

const STALE_IMPERSONATION_ERRORS = new Set([
  'Invalid or expired impersonation session',
  'Impersonation session id is required',
]);

/** True when the API rejected a persisted impersonation overlay (e.g. after logout or TTL expiry). */
export function isStaleImpersonationApiError(message: string | undefined): boolean {
  return !!message && STALE_IMPERSONATION_ERRORS.has(message);
}

/** Drop local impersonation state when the server no longer accepts the session. */
export function clearStaleImpersonationIfNeeded(errorMessage: string | undefined): boolean {
  if (!isStaleImpersonationApiError(errorMessage) || !isImpersonating()) {
    return false;
  }
  useImpersonationStore.getState().clearImpersonation();
  return true;
}
